export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=402accc4ce4a453d2ef37d76f567ee4f3a3b8ddb4a&name=revalidateCommunity!'